import { SurveyAnswerBody } from "../types/working-model";
import { PostHv } from "./helpers";

export const SubmitSurveyAnswer = async (body: SurveyAnswerBody, token?: string | null): Promise<any> => {
	return PostHv('/e3-submit-survey', { ...body }, token || '');
};
